import axios, { AxiosRequestConfig, AxiosRequestHeaders, Method } from "axios";
import { v4 as uuid } from "uuid";
import authorizationStore from "../auth/authorizationStore";
import { HttpMethod } from "../enums";
// @ts-ignore
import { version } from "../../../package.json";
import { getAppNameHeader } from "../utils/apiHeadersUtils";

const commonHeaders = {
  "x-clientid": process.env.REACT_APP_APIGEE_API_KEY
};

const graphqlRequest = (url: string, query: string, method: Method = "POST", headers = {}) => {
  return axios({
    url,
    method,
    data: {
      query
    },
    headers: {
      ...commonHeaders,
      ...headers,
      "X-CorrelationId": uuid()
    }
  } as unknown as AxiosRequestConfig);
};

const graphqlRequestWithBearer = async (url: string, query: string, method: Method = "POST") => {
  const token = await authorizationStore.getToken();
  return graphqlRequest(url, query, method, {
    Authorization: `Bearer ${token}`
  });
};

const magentoGraphqlRequest = (url: string, query: string, store: string) => graphqlRequest(url, query, "POST", { store });

const getRequest = (url: string, headers = {}, params = {}) => {
  const appVersionHeader = url.includes("/graphql") ? {} : { "X-App-Version": version };
  const appNameHeader = url.includes("/graphql") ? {} : getAppNameHeader();

  return axios({
    url,
    method: "GET",
    headers: {
      ...commonHeaders,
      ...headers,
      ...appVersionHeader,
      ...appNameHeader,
      "X-CorrelationId": uuid()
    },
    params
  } as unknown as AxiosRequestConfig);
};

const getRequestWithBearer = async (url: string, params = {}) => {
  const token = await authorizationStore.getToken();
  return getRequest(url, { Authorization: `Bearer ${token}` }, params);
};

const restApiCallWithBearer = async (url: string, method: HttpMethod, body?: any, correlationId?: string) => {
  const token = await authorizationStore.getToken();
  const authHeader = { Authorization: `Bearer ${token}` };
  const appNameHeader = getAppNameHeader();
  return axios(url, {
    method,
    data: body,
    headers: {
      ...commonHeaders,
      ...authHeader,
      ...appNameHeader,
      "X-App-Version": version,
      "X-CorrelationId": correlationId || uuid()
    } as unknown as AxiosRequestHeaders
  });
};

const restApiCall = async (url: string, method: HttpMethod, body?: any) => {
  const appNameHeader = getAppNameHeader();
  return axios(url, {
    method,
    data: body,
    headers: {
      ...commonHeaders,
      ...appNameHeader,
      "X-App-Version": version,
      "X-CorrelationId": uuid()
    } as unknown as AxiosRequestHeaders
  });
};

const restApiCallWithDeviceHmac = async (
  url: string,
  method: HttpMethod,
  deviceId: string,
  hmac: string,
  body?: any,
  forceCorrelationId?: string
) => {
  const headers = { "x-HMAC": hmac, "x-deviceinstanceid": deviceId };
  const appNameHeader = getAppNameHeader();

  return axios(url, {
    method,
    data: body,
    headers: {
      ...commonHeaders,
      ...headers,
      ...appNameHeader,
      "X-App-Version": version,
      "X-CorrelationId": forceCorrelationId || uuid()
    } as unknown as AxiosRequestHeaders
  });
};

const request = {
  graphqlRequest,
  magentoGraphqlRequest,
  graphqlRequestWithBearer,
  getRequest,
  restApiCall,
  getRequestWithBearer,
  restApiCallWithBearer,
  restApiCallWithDeviceHmac
};

export default request;
